import React from 'react';
import { Star } from 'lucide-react';
import { useReviewStats } from '../utils/useReviewStats';
export function ReviewsSummary() {
  const reviewStats = useReviewStats();
  const totalReviews = Object.values(reviewStats).reduce((sum, stat) => sum + stat.count, 0);
  const weightedSum = Object.values(reviewStats).reduce((sum, stat) => sum + stat.avg * stat.count, 0);
  const overallAverage = totalReviews > 0 ? weightedSum / totalReviews : 0;
  const filledStars = Math.round(overallAverage);
  if (totalReviews === 0) {
    return <section className="bg-[#F9F9F9] py-16 md:py-24 px-6 border-t border-[#E5E5E5]" data-id="element-3442" data-mp="27kzxzp30pxj9">
        <div className="max-w-3xl mx-auto text-center" data-id="element-3443" data-mp="1tn1q92j7czcq">
          <div className="flex items-center justify-center gap-1 mb-6" data-id="element-3444" data-mp="1xo52lf21kd97">
            {[...Array(5)].map((_, index) => <Star key={index} className="w-6 h-6 text-[#D8D8D0]" data-id="element-3445" data-mp="i7cxtvn6j84j" data-mpi={index} />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F1F1F] leading-tight tracking-tight mb-4" data-id="element-3446" data-mp="maj3p26dqxah">
            No reviews yet
          </h2>
          <p className="text-base text-[#5A5A5A] leading-relaxed" data-id="element-3447" data-mp="3t0xkc0jl0sit">
            We just launched. Be the first to try our supplements and share your
            experience — your review could be the first one here.
          </p>
        </div>
      </section>;
  }
  return <section className="bg-[#F9F9F9] py-16 md:py-24 px-6 border-t border-[#E5E5E5]" data-id="element-3448" data-mp="6vtwwk3ebl62">
      <div className="max-w-3xl mx-auto text-center" data-id="element-3449" data-mp="krnui6ypyo3v">
        <div className="flex items-center justify-center gap-1 mb-6" data-id="element-3450" data-mp="fuxgdp6h62l3">
          {[...Array(5)].map((_, index) => <Star key={index} className={`w-6 h-6 ${index < filledStars ? 'fill-[#1F73B7] text-[#1F73B7]' : 'text-[#D8D8D0]'}`} data-id="element-3451" data-mp="uia49kjr8ken" data-mpi={index} />)}
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1F1F1F] leading-tight tracking-tight mb-4" data-id="element-3452" data-mp="yl6rjok8p4ox">
          {totalReviews.toLocaleString()} Verified{' '}
          {totalReviews === 1 ? 'Review' : 'Reviews'} From Our Customers
        </h2>
        <p className="text-base text-[#5A5A5A] leading-relaxed" data-id="element-3453" data-mp="17db5402qsli">
          {overallAverage.toFixed(1)} average rating. Every review comes from a
          verified buyer — click any product to read what customers are saying.
        </p>
      </div>
    </section>;
}